// import {FormattedMessage} from "react-intl"
// import React from "react"

export default {
	load() {
		return {
			fields: {
				status: {},
				request_id: {},
				gd_request_id: {},
				places: {},
				ico: {
					label: "IČO",
					rules: "required|between:8,8"
				},
				dic: {
					label: "DIČ",
					rules: "required|between:10,10"
				},
				icdph: {
					label: "IČ DPH",
					rules: ["required", "regex:/^(?=[aA-zZ0-9]*$)(?:.{1}|.{12})$/"]
				},
				companyName: {
					label: "Obchodné meno / žiadateľ",
					rules: "required"
				},
				companyLegalForm: {
					label: "Právna forma",
					rules: "required"
				},
				companyIBAN: {
					label: "IBAN",
					rules: "required",
					value: "SK"
				},
				skNace: {
					label: "SK NACE",
					rules: "required"
				},
				companyStreet: {
					label: "Ulica a číslo",
					rules: "required"
				},
				companyCity: {
					label: "Obec",
					rules: "required"
				},
				// projectCity: {
				// 	label: "Obec",
				// 	rules: "required"
				// },
				// projectStreet: {
				// 	label: "Ulica",
				// 	rules: "required"
				// },
				applicantChipForm: {value: JSON.stringify([{name: ""}])},
				contactPersonName: {
					label: "Priezvisko, Meno, Titul pred, Titul za",
					rules: "required"
				},
				contactPersonPhone: {
					label: "Telefónne číslo",
					rules: "required",
					value: "+421"
				},
				contactPersonMail: {
					label: "Email",
					rules: "email|required"
				},
				authorizedPersonName: {
					label: "Priezvisko, Meno, Titul pred, Titul za"
				},
				authorizedPersonPhone: {
					label: "Telefónne číslo"
				},
				authorizedPersonMail: {
					label: "Email",
					rules: "email"
				},
				round_text: {
					label: "Zvoľte kolo výzvy *"
				},
				methodOfCommunication: {},
				// device: {
				// 	label: "Zariadenie",
				// 	type: "string",
				// 	rules: "required"
				// },
				// devicePower: {
				// 	label: "Výkon zariadenia (kW)",
				// 	type: "string",
				// 	rules: "required"
				// },
				// deviceCapacity: {
				// 	label: "Kapacita akumulácie (kWh)",
				// 	type: "string",
				// 	rules: "required"
				// },
				// deviceCadastralArea: {
				// 	label: "Katastrálne územie (podľa LV)",
				// 	type: "string",
				// 	rules: "required"
				// },
				// deviceParcelNumber: {
				// 	label: "Číslo parcely / parciel",
				// 	type: "string",
				// 	rules: "required"
				// },
				contributionForEnergyAudit: {
					label: "Žiadam o príspevok na vypracovanie energetického auditu",
					type: "checkbox",
					value: false
				},
				personalDataProvided: {
					label: "Beriem na vedomie spracúvanie poskytnutých osobných údajov",
					type: "checkbox",
					value: false
				},
				dropzone: {},
				companySize: {
					label: "Veľkosť podniku",
					rules: "required"
				},
				request_status: {
					label: "Nastavenie stavu žiadosti",
					rules: "required"
				},
				paid_date: {
					label: "Dátum zmeny stavu",
					rules: "required"
				},
				photovoltaic_panels: {
					label: "Finančný príspevok na Fotovoltické panely",
					type: "number"
				},
				heat_pumps: {
					label: "Finančný príspevok na Tepelné čerpadlá",
					type: "number"
				},
				solar_collectors: {
					label: "Finančný príspevok na Slnečné kolektory",
					type: "number"
				},
				wind_turbines: {
					label: "Finančný príspevok na Veterné turbíny",
					type: "number"
				},
				paid_ea_grant: {
					label: "Finančný príspevok na Energetický audit",
					type: "number"
				},
				expected_voucher_amount: {}
			}
		}
	}
}

